import React from 'react';
import { Modal } from './Modal';
import '../styles/modals.css';

interface CreateUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export const CreateUserModal: React.FC<CreateUserModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className="modal-header">
        <h2 style={{ color: '#ffffff' }}>How to Add New Staff Members</h2>
        <button
          className="modal-close"
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>
      </div>

      <div className="modal-body">
        <p style={{ 
          fontSize: '15px', 
          color: '#555', 
          marginBottom: '16px',
          lineHeight: '1.5'
        }}>
          New staff members can create their own account by logging in with their Axis Sports Medicine email address.
        </p>

        <h3 style={{ 
          marginTop: 0, 
          marginBottom: '12px',
          fontSize: '16px', 
          fontWeight: '600',
          color: '#1e293b' 
        }}>
          Steps to Give a Staff Member Access:
        </h3>
        
        <ol style={{ 
          margin: '0 0 16px 0',
          paddingLeft: '24px',
          lineHeight: '1.6'
        }}>
          <li style={{ marginBottom: '12px' }}>
            <strong style={{ color: '#1e293b', fontSize: '15px' }}>
              1. Make sure they have an Axis Sports Medicine email address
            </strong>
            <div style={{ 
              marginTop: '4px',
              fontSize: '14px', 
              color: '#64748b' 
            }}>
              For example: jane.doe@axissportsmedicine.co.nz
            </div>
          </li>

          <li style={{ marginBottom: '12px' }}>
            <strong style={{ color: '#1e293b', fontSize: '15px' }}>
              2. Ask them to visit this website and click "Sign in with Microsoft"
            </strong>
            <div style={{ 
              marginTop: '4px',
              fontSize: '14px', 
              color: '#64748b' 
            }}>
              They'll log in using their Axis email and password
            </div>
          </li>

          <li style={{ marginBottom: '12px' }}>
            <strong style={{ color: '#1e293b', fontSize: '15px' }}>
              3. Their account will be created automatically
            </strong>
            <div style={{ 
              marginTop: '4px',
              fontSize: '14px', 
              color: '#64748b' 
            }}>
              They'll see a "waiting for approval" message and their name will appear in your user list below
            </div>
          </li>

          <li style={{ marginBottom: 0 }}>
            <strong style={{ color: '#1e293b', fontSize: '15px' }}>
              4. Update their role to give them access
            </strong>
            <div style={{ 
              marginTop: '4px',
              fontSize: '14px', 
              color: '#64748b' 
            }}>
              Find them in the list below, click "Edit", and change their role from "Pending" to their job role (e.g., Clinician, Reception, Admin)
            </div>
          </li>
        </ol>

        <div style={{ 
          backgroundColor: '#fef3c7', 
          border: '1px solid #fbbf24', 
          borderRadius: '6px', 
          padding: '12px',
          display: 'flex',
          gap: '10px'
        }}>
          <div style={{ fontSize: '14px', color: '#78350f', lineHeight: '1.5' }}>
            <strong style={{ minWidth: '10px' }}>Important:</strong> Staff members must log in first before you can assign them a role. 
            They will appear in the user list after they complete step 2 above.
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <button className="btn btn-primary" onClick={onClose}>
          Got it
        </button>
      </div>
    </Modal>
  );
};
